window.addEventListener('DOMContentLoaded', () => {
    
    let menuTriggers = document.body.querySelectorAll('#menu-top-holder-phone .menu-item-has-children > a');
    
    let closeMenuButton = document.body.querySelector('span.close-menu');
    closeMenuButton.addEventListener('click', ( e ) => {
        e.preventDefault();
        
        document.getElementById('container-phone-menu').classList.remove( 'open');
        document.body.style.overflow = '';

    });

    [...menuTriggers].map( elem => {
        elem.addEventListener( 'click',e => {
            e.preventDefault();
            let triggered_menu = elem.getAttribute('trigger-menu');

            document.querySelector('nav.dp-menu').classList.add('hidden');

            let menus = document.body.querySelectorAll('nav.dp-submenu');
            [...menus].map( menu => menu.classList.add('hidden') );

            let menu = document.querySelector('[menu-id="'+triggered_menu+'"]');            
            menu.classList.remove( 'hidden' );
        });
    });

    let prevMenu = document.body.querySelectorAll('.dp-menu-navigation-back');
    [...prevMenu].map( elem => {
        elem.addEventListener('click', ( e ) => {
            let targetMenu = elem.getAttribute('parent-menu');

            let menus = document.body.querySelectorAll('nav.dp-submenu');
            [...menus].map( menu => menu.classList.add('hidden') );
            document.querySelector('nav.dp-menu').classList.add('hidden');

            if( targetMenu == 0 ){
                document.querySelector('nav.dp-menu').classList.remove('hidden');
            } else {
                let menu = document.querySelector('[menu-id="'+targetMenu+'"]');
                menu.classList.remove( 'hidden' );
            }

            let menu = document.querySelector('[menu-id="'+targetMenu+'"]');            
            menu.classList.remove( 'hidden' );
        });
    });

    window.addEventListener('resize', () => {
        if( window.innerWidth > 991 ){
            document.body.querySelector('#container-phone-menu').classList.remove('open');
            //document.body.querySelector('#container-phone-user-menu').classList.remove('open');
        }
        if( window.innerWidth < 991 && !window.menu ){
            //menuControler();
        }
    });

    if( window.innerWidth < 991 ){
        //menuControler();
    }

    let nodes = document.body.querySelectorAll('.action-click');

    // document.body.querySelector('.my-account-quick-link').addEventListener('click', ( e ) => {
    //     e.stopPropagation();
    //     document.body.querySelector('#container-phone-menu').classList.remove('open');
    // });

    // document.body.querySelector('#menu-phone').addEventListener('click', ( e ) => {
    //     e.stopPropagation();
    //     document.body.querySelector('#container-phone-user-menu').classList.remove('open');
    // });

    for( let i=0 ; i < nodes.length; i++ ){
        let node = nodes[i];
        node.addEventListener('click', ( e ) => {
            e.stopPropagation();
            
            if( e.currentTarget.getAttribute('action') == 'toggleClass' ){
                let targetNode = document.querySelector( e.currentTarget.getAttribute('action-target') );
                let value = e.currentTarget.getAttribute('action-value');
                if( !targetNode.classList.toggle( value )){
                    document.getElementById('menu-top-holder-phone').style.left="0";    
                }
            }

            if( document.getElementById('container-phone-menu').classList.contains('open')){
                document.body.style.overflow ='hidden';
            } else {
                document.body.style.overflow ='';
            }


        })
    }
    
    let onMenuLeave = ( item ) => {
        setTimeout( () => {
            item.classList.remove('hovered')
        }, 500 )
    }
    document.querySelector('.top-menu-main > .holder').addEventListener( 'mouseleave', () => {
        console.log('leave');
        [...document.querySelectorAll('#menu-menu-glowne > li')].forEach( firstItem => {
            firstItem.classList.remove('hovered');
        });
    });

    [...document.querySelectorAll('#menu-menu-glowne > li')].forEach( firstItem => {
        firstItem.addEventListener('mouseover', ( e ) => {
            [...document.querySelectorAll('#menu-menu-glowne > li')].forEach( firstItem => {
                firstItem.classList.remove('hovered');
            });
            firstItem.classList.add('hovered');
        });
        // firstItem.addEventListener('mouseout', ( e ) => {
        //     e.stopPropagation();
        // });
    });

    [...document.querySelectorAll('#menu-menu-glowne > li .sub-menu-wrap ')].forEach( firtstItem => {
        firtstItem.addEventListener('mouseover', ( e ) => {
            e.stopPropagation();
        });
    });

    [...document.querySelectorAll('.item-slider')].forEach( slider => {
        
        jQuery(slider.querySelector('.collections-slider')).slick({
            infinite: false,
            swipeToSlide:true,
            variableWidth: true,
            prevArrow:slider.querySelector('.slick-prev'),
            nextArrow:slider.querySelector('.slick-next'),
        });

    });

    function menuControler(){
        
        window.menu = true;
        let elemMenu = document.getElementById('menu-top-holder-phone');
        let elemMenuLists = elemMenu.querySelectorAll('ul.sub-menu');
        
        for( let i=0 ; i < elemMenuLists.length; i++){

            let li = document.createElement("li");
            li.innerHTML = '<span class="back-button"><i class="fas fa-chevron-circle-left"></i> TERUG</span>';
            li.className = 'menu-back-element';
            elemMenuLists[i].prepend( li );
            li.addEventListener('click', ( e ) => {
                e.preventDefault();
                e.stopPropagation();
                let parentsCount = 0;
                let parent = li;
                while( parent.parentNode && ( parent.parentNode.nodeName == "LI" || parent.parentNode.nodeName == "UL") ){
                    if( parent.parentNode.nodeName == "UL" )
                        parentsCount++;
                    parent = parent.parentNode;
                }
                elemMenu.style.left = '-' + ( (parentsCount-2) * 100) +'%';

            });

        }

        let a = elemMenu.querySelectorAll('a');

        function listenerClick( e ){
            e.stopPropagation();

            if( window.innerWidth < 991 ){
                let nextMenu =  e.target.parentNode.querySelector( 'ul' );

                let parentsCount = 0;
                let parent = nextMenu;
                while( parent.parentNode && ( parent.parentNode.nodeName == "LI" || parent.parentNode.nodeName == "UL") ){
                    if( parent.parentNode.nodeName == "UL" )
                        parentsCount++;
                    parent = parent.parentNode;
                }

                if( nextMenu ){
                    e.preventDefault();
                    elemMenu.style.left = '-' + (parentsCount * 100) +'%';
                }else {

                }
            }
            
        };

        for( let i=0 ; i < a.length; i++){
            a[i].addEventListener( 'click', listenerClick );
        }

    }

    var filterButton = document.getElementById('filter-by');
    if( filterButton ){
        filterButton.addEventListener('click', function(){
            filterController()
        });
    }
    function filterController(){
        filterContent = '';
    }

    let modalSidebars = document.querySelectorAll('.modal-sidebar');
    [...modalSidebars].map( ( elem ) => {
        let opener = elem.querySelector('.modal-open');
        opener.addEventListener('click', () => {
            elem.querySelector('.close-icon').addEventListener('click', ( e ) => {
                e.stopPropagation();
                elem.querySelector('.modal-sidebar-content').classList.remove('open');
            });
            elem.querySelector('.modal-sidebar-content').classList.add('open');
        });
    });

    let allQuickViews = document.querySelectorAll('.quick-preview-product');

    [...allQuickViews].map( elem => {
        elem.addEventListener('click', ( e ) => {
            e.preventDefault();
            createModalPreview( elem.getAttribute('product-id') );
        })
    } );

    function createModalPreview( productID ){

        const data = new FormData();

        data.append( 'action', 'product_preview' );      
        data.append( 'productid', productID);
        
        let modal = document.getElementById('modal-product-prev');
        modal.querySelector('.modal-body').innerHTML = '<div class="d-flex w-100 h-100 align-items-center justify-content-center"><div class="spinner-border" role="status"><span class="sr-only">Loading...</span></div></div>';
        jQuery(modal).modal();
        
        jQuery.ajax( frontendajax.ajaxurl,
            {
                method: 'POST',
                data: {
                action: 'product_preview', 
                product_id: productID
            }
        }).done( ( resp ) => {

            modal.querySelector('.modal-body').innerHTML = resp;
            let slider = document.getElementById('product-previev-slider-' + productID);
            setTimeout( () => {
                //jQuery('.carousel').carousel( slider.querySelector('.previev-slider'))
                jQuery( slider.querySelector('.previev-slider')).slick({
                    infinite: true,
                    swipeToSlide:true, 
                    centerMode: true,
                    centerPadding: '60px',
                    prevArrow: slider.querySelector('.slick-prev'),
                    nextArrow: slider.querySelector('.slick-next'),
                    responsive: [ {
                  
                        breakpoint: 600,
                        settings: {
                            centerPadding: '0px',
                            slidesToShow: 1,
                            variableWidth: false,
                        }
                  
                      }]
                });
                modal.querySelector('.pp-slider').classList.add('loaded');
            }, 150);

        });

    }

    function initGallery( elem ){
        if( !elem ){
            return;
        }
        [...elem.querySelectorAll('a')].map( (link, index) => {
            link.addEventListener('click', e => {
                e.preventDefault();
                e.stopPropagation();
                let items = [...elem.querySelectorAll('a')].map( _elem => {  
                    return { 
                        src: _elem.getAttribute('href'), 
                        msrc: _elem.querySelector('img').getAttribute('src'), 
                        w: _elem.getAttribute('data-width'), 
                        h:  _elem.getAttribute('data-height'), 
                    }; 
                });
                
                var options = {
                    // optionName: 'option value'
                    // for example:
                    index: index // start at first slide
                };
                var gallery = new PhotoSwipe( document.querySelectorAll('.pswp')[0], PhotoSwipeUI_Default, items, options);
                gallery.init();
            });
        });
        
        
    }   
    initGallery(document.querySelector('.gallery-grid'));

});


/*
window.addEventListener('DOMContentLoaded', () =>{
    
    window.addEventListener('resize', () => {
        if( window.innerWidth > 991 ){
            document.body.querySelector('#container-phone-menu').classList.remove('open');
            document.body.querySelector('#container-phone-user-menu').classList.remove('open');
        }
        if( window.innerWidth < 991 && !window.menu ){
            //menuControler();
        }
    });

    if( window.innerWidth < 991 ){
        //menuControler();
    }

    let nodes = document.body.querySelectorAll('.action-click');

    for( let i=0 ; i < nodes.length; i++ ){
        let node = nodes[i];
        node.addEventListener('click', ( e ) => {
            e.stopPropagation();
            
            if( e.currentTarget.getAttribute('action') == 'toggleClass' ){
                let targetNode = document.querySelector( e.currentTarget.getAttribute('action-target') );
                let value = e.currentTarget.getAttribute('action-value');
                if( !targetNode.classList.toggle( value )){
                    document.getElementById('menu-top-holder-phone').style.left="0";    
                }
            }

        })
    }

    function menuControler(){
        
        window.menu = true;
        let elemMenu = document.getElementById('menu-top-holder-phone');
        let elemMenuLists = elemMenu.querySelectorAll('ul.sub-menu');
        
        for( let i=0 ; i < elemMenuLists.length; i++){

            let li = document.createElement("li");
            li.innerHTML = '<span class="back-button"><i class="fas fa-chevron-circle-left"></i> TERUG</span>';
            li.className = 'menu-back-element';
            elemMenuLists[i].prepend( li );
            li.addEventListener('click', ( e ) => {
                e.preventDefault();
                e.stopPropagation();
                let parentsCount = 0;
                let parent = li;
                while( parent.parentNode && ( parent.parentNode.nodeName == "LI" || parent.parentNode.nodeName == "UL") ){
                    if( parent.parentNode.nodeName == "UL" )
                        parentsCount++;
                    parent = parent.parentNode;
                }
                elemMenu.style.left = '-' + ( (parentsCount-2) * 100) +'%';

            });

        }

        let a = elemMenu.querySelectorAll('a');

        function listenerClick( e ){
            e.stopPropagation();

            if( window.innerWidth < 991 ){
                let nextMenu =  e.target.parentNode.querySelector( 'ul' );

                let parentsCount = 0;
                let parent = nextMenu;
                while( parent.parentNode && ( parent.parentNode.nodeName == "LI" || parent.parentNode.nodeName == "UL") ){
                    if( parent.parentNode.nodeName == "UL" )
                        parentsCount++;
                    parent = parent.parentNode;
                }

                if( nextMenu ){
                    e.preventDefault();
                    elemMenu.style.left = '-' + (parentsCount * 100) +'%';
                }else {

                }
            }
            
        };

        for( let i=0 ; i < a.length; i++){
            a[i].addEventListener( 'click', listenerClick );
        }

    }

    var filterButton = document.getElementById('filter-by');
    if( filterButton ){
        filterButton.addEventListener('click', function(){
            filterController()
        });
    }
    function filterController(){
        filterContent = '';
    }

    let modalSidebars = document.querySelectorAll('.modal-sidebar');
    [...modalSidebars].map( ( elem ) => {
        let opener = elem.querySelector('.modal-open');
        opener.addEventListener('click', () => {
            elem.querySelector('.close-icon').addEventListener('click', ( e ) => {
                e.stopPropagation();
                elem.querySelector('.modal-sidebar-content').classList.remove('open');
            });
            elem.querySelector('.modal-sidebar-content').classList.add('open');
        });
    });

});
*/